import React from 'react'
import { withTranslation } from 'react-i18next'
import CampaignSearchInput from './CampaignSearchInput'
import FilterDropdown from './FilterDropdown'
import PeriodRangeFilter from './PeriodRangeFilter'
import BudgetRangeFilter from './BudgetRangeFilter'

export default withTranslation()(function CampaignFilterBar({
  t, search, onChangeSearch, period, onChangePeriod, status, onChangeStatus, budget, onChangeBudget
}) {
  const statusOptions = [
    { label: t('promo.listing.filters.all_statuses'), value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Pending', value: 'pending' },
    { label: 'Completed', value: 'completed' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 py-4 border-b border-border-lines">
      <CampaignSearchInput
        value={search}
        onChange={onChangeSearch}
        placeholder={t('promo.listing.filters.search_placeholder')}
      />

      <PeriodRangeFilter
        from={period.from}
        to={period.to}
        onApply={(from, to) => onChangePeriod({ from, to })}
        onClear={() => onChangePeriod({ from: '', to: '' })}
      />

      <FilterDropdown
        label={t('promo.listing.filters.all_statuses')}
        active={status ? statusOptions.find((option) => option.value === status)?.label : null}
        panel={({ close }) => (
          <ul className="flex flex-col">
            {
              statusOptions.map((option) => (
                <li key={option.value || 'all'}>
                  <button
                    type="button"
                    onClick={() => { onChangeStatus(option.value); close() }}
                    className="w-full text-left px-2 py-2 text-sm text-dark-blue hover:bg-background rounded-lg"
                  >
                    {option.label}
                  </button>
                </li>
              ))
            }
          </ul>
        )}
      />

      <BudgetRangeFilter
        min={budget.min}
        max={budget.max}
        onApply={(min, max) => onChangeBudget({ min, max })}
        onClear={() => onChangeBudget({ min: 0, max: 0 })}
      />
    </div>
  )
})
